import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resets scroll position to the top on every route change.
 * SPAs don't reset scroll on navigation by default, and WKWebView
 * (iOS native app) preserves the document scroll offset across route
 * changes — which left pages loading pre-scrolled after login.
 */
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
